import {
  IonButton,
  IonCol,
  IonGrid,
  IonInput,
  IonPage,
  IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import {
  allExercisesState,
  duplicateExercisePlanState,
} from "../../data/atoms";
import { useRecoilState, useRecoilValue } from "recoil";

interface Props {
  editExerciseModal: Function;
  exerciseData: any;
  index: number;
}

const EditExercisesModal: React.FC<Props> = ({
  editExerciseModal,
  exerciseData,
  index,
}) => {
  const [isDropDown, setIsDropDown] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isError, setIsError] = useState<any>({
    noOfSets: false,
    repsOrDuration: false,
    noOfTimes: false,
    noOfDays: false,
    hold: false,
    noOfWeeks: false,
  });

  const toggleDropdown = () => {
    setIsDropDown(!isDropDown);
  };
  const allExercises = useRecoilValue(allExercisesState);
  const [selectedRep, setSelectedRep] = useState<number>(0);
  const [duplicateExercisePlan, setDuplicateExercisePlan] = useRecoilState(
    duplicateExercisePlanState,
  );
  // const [newDuplicateExercisePlan, setNewDuplicateExercisePlan] =
  //   useRecoilState(newDuplicateExercisePlanState);
  const reviewExercise = useRecoilValue(duplicateExercisePlanState);
  const [formData, setFormData] = useState<any>({
    noOfSets: exerciseData.testExercises[0].noOfSets,
    hold: exerciseData.testExercises[0].hold,
    repsOrDuration: exerciseData.testExercises[0].repsOrDuration,
    repsOrDurationUnit: exerciseData.testExercises[0].repsOrDurationUnit,
    sideName: "",
    repsId: exerciseData.testExercises[0].repsId,
    noOfTimes: exerciseData.testExercises[0].noOfTimes,
    noOfDays: exerciseData.testExercises[0].noOfDays,
    noOfWeeks: exerciseData.testExercises[0].noOfWeeks,
  });

  // console.log("exerciseData", exerciseData);

  const selectedRepChange = (event: any) => {
    debugger;
    setSelectedRep(event);
    setIsDropDown(!isDropDown);
    setFormData({
      ...formData,
      ["sideName"]: allExercises.sidesLookup[event - 1].sideName,
      ["repsId"]: allExercises.sidesLookup[event - 1].id,
    });
  };

  const editExerciseModal1 = (value: any, type: any) => {
    const numericFields = [
      "noOfSets",
      "hold",
      "repsOrDuration",
      "noOfTimes",
      "noOfDays",
      "noOfWeeks",
    ];
    const convertedValue = numericFields.includes(type) ? Number(value) : value;
    setFormData({ ...formData, [type]: convertedValue });
  };

  const submitForm = () => {
    // console.log("formData", duplicateExercisePlan);
    // console.log("formData", newDuplicateExercisePlan);
    let temp: any = JSON.parse(JSON.stringify(duplicateExercisePlan));
    let isErrorFound: boolean = false;
    let obj: any = {};
    // let temp: any = JSON.parse(JSON.stringify(newDuplicateExercisePlan));

    if (formData.noOfSets === "" || formData.noOfSets <= 0) {
      // setIsError({
      //   ...isError,
      //   ["noOfSets"]: true,
      // });
      // setErrorMsg(true);
      // return;
      obj.noOfSets = true;
      isErrorFound = true;
    }
    if (formData.repsOrDuration === "" || formData.repsOrDuration <= 0) {
      // setIsError({
      //   ...isError,
      //   ["repsOrDuration"]: true,
      // });
      // setErrorMsg(true);
      // return;
      obj.repsOrDuration = true;
      isErrorFound = true;
    }
    if (formData.noOfTimes === "" || formData.noOfTimes <= 0) {
      // setIsError({
      //   ...isError,
      //   ["noOfTimes"]: true,
      // });
      // setErrorMsg(true);
      // return;
      obj.noOfTimes = true;
      isErrorFound = true;
    }
    if (formData.noOfDays === "" || formData.noOfDays <= 0 || formData.noOfDays > 7) {
      // setIsError({
      //   ...isError,
      //   ["noOfDays"]: true,
      // });
      // setErrorMsg(true);
      // return;
      obj.noOfDays = true;
      isErrorFound = true;
    }
    if (formData.hold === "" || formData.hold <= 0) {
      // setIsError({
      //   ...isError,
      //   ["hold"]: true,
      // });
      // setErrorMsg(true);
      // return;
      obj.hold = true;
      isErrorFound = true;
    }
    if (formData.noOfWeeks === "" || formData.noOfWeeks <= 0) {
      obj.noOfWeeks = true;
      isErrorFound = true;
    }

    if (isErrorFound) {
      setIsError({
        ...isError,
        ["noOfSets"]: obj.noOfSets ? true : false,
        ["repsOrDuration"]: obj.repsOrDuration ? true : false,
        ["noOfTimes"]: obj.noOfTimes ? true : false,
        ["noOfDays"]: obj.noOfDays ? true : false,
        ["hold"]: obj.hold ? true : false,
        ["noOfWeeks"]: obj.noOfWeeks ? true : false,
      });
      if (obj.noOfDays && formData.noOfDays > 7) {
        setErrorMessage("Maximum limit is 7 days.");
      } else {
        setErrorMessage("Please enter number greater than zero.");
      }
      setErrorMsg(true);
      return;
    }

    let updateExercise = temp.exercises.map((item: any) => {
      if (item.testExercises[0].id !== index) {
        return item;
      }
      item.testExercises[0].noOfSets = formData.noOfSets;
      item.testExercises[0].hold = formData.hold;
      item.testExercises[0].repsOrDuration = formData.repsOrDuration;
      item.testExercises[0].repsOrDurationUnit = formData.repsOrDurationUnit;
      item.testExercises[0].sideName = formData.sideName;
      item.testExercises[0].noOfTimes = formData.noOfTimes;
      item.testExercises[0].noOfDays = formData.noOfDays;
      item.testExercises[0].noOfWeeks = formData.noOfWeeks;
      item.testExercises[0].repsId = formData.repsId;

      return item;
    });
    debugger;
    setDuplicateExercisePlan((prevState: any) => ({
      ...prevState,
      exercises: updateExercise,
    }));
    // setNewDuplicateExercisePlan((prevState: any) => ({
    //   ...prevState,
    //   exercises: updateExercise,
    // }));
    editExerciseModal(false);
  };

  useEffect(() => {
    if (duplicateExercisePlan.exercises.length > 0) {
      duplicateExercisePlan.exercises.filter((item: any) => {
        if (item.testExercises[0].id === exerciseData.testExercises[0].id) {
          if (item.testExercises[0].repsId != null) {
            setSelectedRep(item.testExercises[0].repsId);
          }
        }
      });
    }
  });

  return (
    <IonPage placeholder={undefined} className="edit-exercise-modal dd">
      <div className="main-header-sec">
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row align-items-center" placeholder={undefined}>
            <IonCol className="col-sec" size="2" placeholder={undefined}>
              <div
                className="cross-icon-wrap"
                onClick={() => {
                  editExerciseModal(false);
                }}
              >
                <svg
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.43934 0.834112C1.02513 0.200661 1.97487 0.200661 2.56066 0.834112L13.5606 12.729C14.1463 13.3625 14.1463 14.3895 13.5606 15.023C12.9748 15.6564 12.025 15.6564 11.4392 15.023L0.43934 3.12804C-0.146447 2.49459 -0.146447 1.46756 0.43934 0.834112Z"
                    fill="#31344E"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.5606 0.834112C14.1464 1.46756 14.1464 2.49459 13.5606 3.12804L2.56066 15.023C1.97487 15.6565 1.02513 15.6565 0.43934 15.023C-0.146447 14.3896 -0.146447 13.3626 0.43934 12.7291L11.4393 0.834112C12.0251 0.200661 12.9748 0.200661 13.5606 0.834112Z"
                    fill="#31344E"
                  />
                </svg>
              </div>
            </IonCol>
            <IonCol className="col-sec" size="8" placeholder={undefined}>
              <div className="header-tile-sec text-center">
                <h1>Edit Exercises</h1>
              </div>
            </IonCol>
            <IonCol
              className="col-sec"
              size="2"
              placeholder={undefined}
            ></IonCol>
          </IonRow>
        </IonGrid>
      </div>
      <div className="edit-exercise-form-main-wrap">
        <form>
          <div className="edit-exercise-form-wrap">
            {errorMsg && (
              <div className="error-tooltip-msg">
                <p>{errorMessage}</p>
              </div>
            )}
            <ul>
              <li className={` ${isError.noOfSets ? "error" : ""}`}>
                <label>Sets*</label>
                <IonInput
                  type="number"
                  value={formData.noOfSets}
                  placeholder={undefined}
                  className="edit-ex-input-field"
                  onIonChange={(e) =>
                    editExerciseModal1(e.target.value, "noOfSets")
                  }
                ></IonInput>
              </li>
              <li>
                <label>Weight (lbs.)</label>
                <IonInput
                  type="number"
                  value={formData.weight}
                  placeholder={undefined}
                  className="edit-ex-input-field disabled"
                ></IonInput>
              </li>
              <li className={`${isError.hold ? "error w-100" : "w-100"}`}>
                <label>Hold (seconds)*</label>
                <IonInput
                  type="number"
                  value={formData.hold}
                  placeholder={undefined}
                  className="edit-ex-input-field"
                  onIonChange={(e) =>
                    editExerciseModal1(e.target.value, "hold")
                  }
                ></IonInput>
              </li>
              <li className={` ${isError.repsOrDuration ? "error" : ""}`}>
                <label>Reps*</label>
                <IonInput
                  type="number"
                  value={formData.repsOrDuration}
                  placeholder={undefined}
                  className="edit-ex-input-field"
                  onIonChange={(e) =>
                    editExerciseModal1(e.target.value, "repsOrDuration")
                  }
                ></IonInput>
              </li>
              <li>
                <div
                  className={`custom-dropdown-wrap ${isDropDown ? "open" : ""}`}
                >
                  <div
                    className="dropdown-input edit-ex-input-field"
                    onClick={() => {
                      toggleDropdown();
                    }}
                  >
                    {selectedRep === 0
                      ? ""
                      : allExercises.sidesLookup[selectedRep - 1].sideName}
                  </div>

                  <div className="dropdown-item-wrap">
                    {allExercises.sidesLookup.map((item: any) => {
                      return (
                        <div
                          className="dropdown-item"
                          onClick={() => selectedRepChange(item.id)}
                        >
                          {item.sideName}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </li>
              <li className={`w-100 ${isError.noOfTimes ? "error" : ""}`}>
                <label>Frequency (times/day)*</label>
                <IonInput
                  type="number"
                  value={formData.noOfTimes}
                  placeholder={undefined}
                  className="edit-ex-input-field"
                  onIonChange={(e) =>
                    editExerciseModal1(e.target.value, "noOfTimes")
                  }
                ></IonInput>
              </li>
              <li className={`w-100 ${isError.noOfDays ? "error" : ""}`}>
                <label>Frequency (days/week)*</label>
                <IonInput
                  type="number"
                  value={formData.noOfDays}
                  placeholder={undefined}
                  className="edit-ex-input-field"
                  onIonChange={(e) =>
                    editExerciseModal1(e.target.value, "noOfDays")
                  }
                ></IonInput>
              </li>
              <li className={`w-100 ${isError.noOfWeeks ? "error" : ""}`}>
                <label>No of Weeks*</label>
                <IonInput
                  type="number"
                  value={formData.noOfWeeks}
                  placeholder={undefined}
                  className="edit-ex-input-field"
                  onIonChange={(e) =>
                    editExerciseModal1(e.target.value, "noOfWeeks")
                  }
                ></IonInput>
              </li>
            </ul>
          </div>
        </form>
      </div>
      <div className="ion-no-border duplicate-ex-page-footer">
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="two-col-btn">
                <IonButton
                  placeholder={undefined}
                  className="blue-outline-btn"
                  onClick={() => {
                    editExerciseModal(false);
                  }}
                >
                  Cancel
                </IonButton>
                <IonButton
                  placeholder={undefined}
                  className="blue-btn"
                  onClick={submitForm}
                >
                  Save
                </IonButton>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </div>
    </IonPage>
  );
};
export default EditExercisesModal;
